module.exports = __webpack_public_path__ + "static/fipclambmain-7aa12723b0342c33f21a3ca1c64a5341.jpeg";